// PRODUCT CAROUSEL CUSTOM SCRIPT

document.addEventListener("DOMContentLoaded", function () {
    function productMediaThumbCon() {
        // Add the logic for `productMediaThumbCon()` function here
        console.log("Executing productMediaThumbCon()");

        setPagerWidth();
    }

    function setPagerWidth() {
        const productMediaList = document.querySelector('.product__media-wrapper .carousel-thumb-container .product__media-list');
        const sliderButtons = document.querySelector('.media-style__carousel_w_thumb .product__media-wrapper > slider-component .slider-buttons');

        if (productMediaList && sliderButtons) {
            let productMediaThumbConWidth = productMediaList.offsetWidth + 105;
            sliderButtons.style.maxWidth = productMediaThumbConWidth + 'px';
        }
    }

    function checkWindowSize() {
        let windowWidth = window.innerWidth;
        if (windowWidth <= 989) {
            productMediaThumbCon();
        }
    }

    // Initial check on page load
    checkWindowSize();

    // Re-check on window resize
    window.addEventListener("resize", checkWindowSize);
});

// document.addEventListener("DOMContentLoaded", function () {
//     const mediaList = document.querySelector('.product__media-wrapper > slider-component .product__media-list.grid');

//     if (mediaList) {
//         const firstMediaItem = mediaList.querySelector('.product__media-item:nth-child(1)');
        
//         if (firstMediaItem) {
//             // Clone the first media item
//             const clonedItem = firstMediaItem.cloneNode(true);
            
//             // Remove 'active' class and reset 'data-media-id' and 'id' attributes
//             clonedItem.classList.remove('active');
//             clonedItem.removeAttribute('data-media-id');
//             clonedItem.removeAttribute('id');
            
//             // Prepend the cloned item to the list
//             mediaList.insertBefore(clonedItem, mediaList.firstChild);
//         }
//     }
// });


document.addEventListener("DOMContentLoaded", function () {
    const mediaList = document.querySelector('.product__media-wrapper .carousel-thumb-container .product__media-list');

    if (mediaList) {
        const observer = new MutationObserver(() => {
            const activeItem = document.querySelector('.product__media-wrapper .carousel-thumb-container .product__media-list li.active');
            
            if (activeItem) {
                const dataImgId = activeItem.getAttribute('data-media-id');

                // Remove 'active' class from all product media items
                document.querySelectorAll('.product__media-wrapper > slider-component .product__media-list.grid .product__media-item')
                    .forEach(mediaItem => mediaItem.classList.remove('active'));

                // Add 'active' class to the matching media item
                const matchingItem = document.querySelector(`.product__media-wrapper > slider-component .product__media-list.grid .product__media-item[data-media-id="${dataImgId}"]`);
                if (matchingItem) {
                    matchingItem.classList.add('active');
                }
            }
        });

        // Observe changes in all <li> elements inside .product__media-list
        observer.observe(mediaList, {
            subtree: true,  // Watch for changes in child elements
            attributes: true,  // Watch for attribute changes (class changes)
            attributeFilter: ['class'] // Only trigger on class attribute changes
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const mediaList = document.querySelector('.product__media-wrapper .carousel-thumb-container .product__media-list');
    
    if (mediaList) {
        // Set up a MutationObserver to detect class changes in <li> elements
        const observer = new MutationObserver(() => {
            // Remove 'disable' class from all buttons
            document.querySelectorAll('.media-style__carousel_w_thumb .product__media-wrapper > slider-component .slider-buttons button')
                .forEach(button => button.classList.remove('disable'));

            const mediaListItems = document.querySelectorAll('.product__media-wrapper .carousel-thumb-container .product__media-list li');

            // Check if the first <li> has the 'active' class
            if (mediaListItems.length > 0 && mediaListItems[0].classList.contains('active')) {
                const prevButton = document.querySelector('.media-style__carousel_w_thumb .product__media-wrapper > slider-component .slider-buttons button.slider-button--prev');
                if (prevButton) {
                    prevButton.classList.add('disable');
                }
            }

            // Check if the last <li> has the 'active' class
            if (mediaListItems.length > 0 && mediaListItems[mediaListItems.length - 1].classList.contains('active')) {
                const nextButton = document.querySelector('.media-style__carousel_w_thumb .product__media-wrapper > slider-component .slider-buttons button.slider-button--next');
                if (nextButton) {
                    nextButton.classList.add('disable');
                }
            }
        });

        // Start observing the <li> elements for changes in the 'class' attribute
        observer.observe(mediaList, {
            subtree: true,  // Watch for changes in child elements
            attributes: true,  // Watch for attribute changes (class changes)
            attributeFilter: ['class'] // Only trigger on class attribute changes
        });
    }
});

// END PRODUCT CAROUSEL CUSTOM SCRIPT